import React from 'react';
import { TextEditorProps } from './types';
import QuillTextEditor from './editors/quill';

const TextEditor = (props: TextEditorProps) => {
  return <QuillTextEditor {...props} />;
};

export default TextEditor;
